<template>
  <div class="main-header">
    <!-- <div class="first-title title-box">
      <div class="title">
        {{ title.firstTitile }}
      </div>
      <div class="user-info">
        <el-popover placement="bottom-end" width="100" trigger="hover">
          <el-menu>
            <el-menu-item index="2" @click="logout">
              <i class="el-icon-document"></i>
              <span slot="title">退出账号</span>
            </el-menu-item>
          </el-menu>
          <p slot="reference">
            <span class="username">{{ userInfo.nickname }}</span>
            <i class="el-icon-arrow-right icon"></i>
          </p>
        </el-popover>
      </div>
    </div> -->
    <div class="second-title title-box" v-if="title.secondTitle">
      <div class="title">
        <span>{{ title.firstTitile }} / </span>
        {{ title.secondTitle }}
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapGetters, mapMutations } from 'vuex';
export default {
  components: {},
  name: 'main-header',
  data() {
    return {};
  },
  props: {
    title: {
      type: Object,
      value: {}
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    ...mapMutations(['clearToken']),
    logout() {
      // 退出账号
      this.httpPost(this.$root.managerLogout).then(
        (res) => {
          this.clearToken();
          this.$router.push('login');
        },
        () => {
          this.$message({
            message: '退出失败',
            type: 'error'
          });
        }
      );
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.main-header {
  width: 100%;
  // height: 120px;
  // min-height: 120px;
  flex-y();

  .title-box {
    height: 36px;
    min-height: 36px;
    width: 100%;
    flex-x();
    background: #FAFAFA;
    padding: 0 24px;
    box-sizing: border-box;
    color: white;
    font-size: 14px;
  }

  .first-title {
    .user-info {
      flex-x();
      height: 100%;

      .icon {
        font-size: 14px;
        height: 24px;
        line-height: 24px;
        margin: 0;
        cursor: pointer;
        color: white;
        margin-left: 6px;
      }

      .setting {
        margin-left: 40px;
      }

      .divider {
        width: 0;
        border-right: 1px solid white;
        height: 80%;
        margin: 0 30px;
      }

      .username {
        cursor: pointer;
        color: white;
      }
    }
  }

  .second-title {
    background: #FAFAFA;
    color: #333;
    font-size: 14px;

    .title {
      padding: 0 12px;
      height: 54px;
      line-height: 54px;
      box-sizing: border-box;
      // border-bottom: 2px solid btn-color;
      span{
        color: #999;
      }
    }
  }
}
</style>
